import { FC } from 'react';
import { Box } from 'ui/Box';
import { Skeleton } from 'ui/Skeleton';
import { clsx } from 'clsx';

interface LoaderProps {
  className?: string;
}
export const Loader: FC<LoaderProps> = ({ className }) => {
  return (
    <Box
      className={clsx(
        'mb-3 flex w-max items-center justify-center gap-2 rounded-lg bg-gray-100 p-3',
        className
      )}
    >
      <Skeleton className="h-2 w-2" variant="circular" />
      <Skeleton className="h-2 w-2" variant="circular" />
      <Skeleton className="h-2 w-2" variant="circular" />
    </Box>
  );
};
